import { h } from 'preact';

export default () => {
  return (
    <div class='vpn-client step'>
      <h3>Step 1</h3>
      <p>
        Download and install Tunnelblick, an OpenVPN client. While installing,
        select "I have configuration files." We will generate them next.
      </p>
      <a
        href='https://tunnelblick.net/index.html'
        class='button'
        target='_blank'
      >Download Client</a>
      <img src='assets/tunnelblick-cfg.png' />
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/vpn_client/index.js